import React from 'react';

// ============================================================================
// Slider — the form-controls standard for percent-ish values where the
// shape matters more than the exact number (unit fullness, capacity
// thresholds). Drag for the shape, read the number beside it. Snaps to
// `step` (default 5). (form-controls.md "Slider: A")
//
// The native range input is the one native control the standard keeps
// (it renders consistently and has no tiny hit box — the thumb is the
// target); it's wrapped here so every slider shows its live value and
// uses the brand accent. Don't use a bare <input type="range"> elsewhere.
//
// value (number), onChange(number), min, max, step, format(v) → label,
// ariaLabel, disabled, size ('md' | 'sm').
// ============================================================================

export default function Slider({ value, onChange, min = 0, max = 100, step = 5, format, ariaLabel, disabled = false, size = 'md', className = '' }) {
    const n = Number.isFinite(Number(value)) ? Number(value) : min;
    const label = format ? format(n) : String(n);
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <input
                type="range"
                min={min} max={max} step={step}
                value={n}
                disabled={disabled}
                aria-label={ariaLabel}
                onChange={e => onChange?.(Number(e.target.value))}
                className={`flex-1 min-w-0 ${size === 'sm' ? 'h-7' : 'h-9'} cursor-pointer disabled:cursor-not-allowed`}
                style={{ accentColor: '#dc2626' }}
            />
            <span className={`font-mono font-bold tabular-nums text-right text-slate-800 ${size === 'sm' ? 'text-[12px] min-w-[40px]' : 'text-sm min-w-[52px]'}`} aria-live="polite">{label}</span>
        </div>
    );
}
